"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _MenuContext = require("./MenuContext");
var _LinkWrap = _interopRequireDefault(require("./LinkWrap"));
var _excluded = ["className", "style", "title", "icon", "selected", "onClick", "element", "message"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MenuItem = function MenuItem(props) {
  var className = props.className,
    style = props.style,
    title = props.title,
    icon = props.icon,
    selected = props.selected,
    onClick = props.onClick,
    element = props.element,
    message = props.message,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('menu');
  var _ref = Array.isArray(icon) ? icon : [icon, icon],
    _ref2 = (0, _slicedToArray2.default)(_ref, 2),
    defaultIcon = _ref2[0],
    activeIcon = _ref2[1];

  // 子菜单被选中项
  var _useContext = (0, _react.useContext)(_MenuContext.SubMenuContext),
    inSubMenu = _useContext.inSubMenu,
    onSelectedChange = _useContext.onSelectedChange;
  var _useContext2 = (0, _react.useContext)(_MenuContext.MenuContext),
    parentElement = _useContext2.element;
  var idRef = (0, _react.useRef)(String(Math.random() * 1000));
  (0, _react.useEffect)(function () {
    if (selected === undefined) return;
    onSelectedChange(idRef.current, selected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)("".concat(prefixCls, "__item"), {
      'is-selected': selected
    }, {
      'has-message': message
    }, className),
    style: style,
    onClick: onClick
  }, (0, _LinkWrap.default)({
    element: element || parentElement,
    props: _objectSpread({
      className: "".concat(prefixCls, "__link")
    }, extraProps),
    children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !inSubMenu && /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__icon")
    }, !!defaultIcon && (typeof defaultIcon === 'string' ? /*#__PURE__*/_react.default.createElement("img", {
      src: defaultIcon,
      alt: "icon"
    }) : defaultIcon), !!activeIcon && (typeof activeIcon === 'string' ? /*#__PURE__*/_react.default.createElement("img", {
      className: "is-selected",
      src: activeIcon,
      alt: "icon"
    }) : activeIcon)), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__text")
    }, title), message && /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__message")
    }, message))
  }));
};
var _default = MenuItem;
exports.default = _default;